// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__s2P3U","dragIcon":"SortableItem_dragIcon__OCx_j","disabled":"SortableItem_disabled__3OknE"};